export default __webpack_public_path__ + "static/media/check-rounded.c5ca52ed.svg";